import React, { FC } from "react";

const basicLine: FC = () => {
    return (
        <svg viewBox="0 0 35 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 6C0 2.68629 2.68629 0 6 0H29C32.3137 0 35 2.68629 35 6V21C35 24.3137 32.3137 27 29 27H6C2.68629 27 0 24.3137 0 21V6Z"
                fill="#BFBFBF"
            />
            <path
                d="M12.9997 19.838C12.9997 19.838 14.8357 20.09 17.4637 20.09C20.9197 20.09 22.1977 18.884 22.1977 16.67V16.058C22.1977 14.852 21.6397 13.97 20.2897 13.538C21.4957 13.106 22.0177 12.278 22.0177 11.144V10.658C22.0177 8.48 20.7757 7.31 17.4637 7.31C14.8357 7.31 12.9997 7.562 12.9997 7.562V19.838ZM16.0237 14.492H17.4637C18.7777 14.492 19.1737 14.96 19.1737 16.058V16.67C19.1737 17.786 18.7777 18.182 17.4637 18.182H16.0237V14.492ZM16.0237 9.218H17.4637C18.6157 9.218 18.9937 9.65 18.9937 10.658V11.144C18.9937 12.188 18.6157 12.638 17.4637 12.638H16.0237V9.218Z"
                fill="white"
            />
        </svg>
    );
};

export default React.memo(basicLine);
